import { chartAssets } from '../../constants/assets'
import { cn } from '../../utils/cn'
import { absoluteBox } from '../../utils/geometry'
import { MoneyLabel } from '../ui/MoneyLabel'

type RevenueTooltipProps = {
  period: string
  amount: string
  x: number
  y: number
  visible?: boolean
}

/** The white callout pinned above the highlighted month. */
export const RevenueTooltip = ({ period, amount, x, y, visible = true }: RevenueTooltipProps) => (
  <div
    className={cn(
      'absolute transition-[opacity,transform] duration-300 motion-reduce:transition-none',
      visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-1 opacity-0',
    )}
    style={absoluteBox({ x, y, width: 76, height: 46 })}
  >
    <span className="absolute bottom-[-0.38%] left-[-1.32%] right-[-1.32%] top-[-2.17%] block">
      <img alt="" aria-hidden className="block size-full max-w-none" src={chartAssets.tooltip} />
    </span>

    <p className="absolute left-[13px] top-[4px] whitespace-nowrap font-host text-[10px] font-medium leading-normal text-black">
      {period}
    </p>

    <MoneyLabel amount={amount} className="absolute left-[16px] top-[20px] w-[44px]" />
  </div>
)
